export const shieldsOptions = [
  {
    value: "magic",
    label: "Magiczne",
    searchOptions: {
      isMagic: true,
    },
  },
  {
    value: "normal",
    label: "Zwykłe",
    searchOptions: {
      isMagic: false,
    },
  },
  {
    value: "all",
    label: "Wszystkie",
    searchOptions: {},
  },
];
